import { Component, inject } from '@angular/core';
import { AppInitializerService, AppService, UserAgentService } from '@lc/core';

@Component({
  selector: 'lc-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  constructor() {
    const appInitializer = inject(AppInitializerService);
    const userAgentService = inject(UserAgentService);

    userAgentService.doBrowserCheck();
    appInitializer.initializeKeys('lc-admin-app', AppService.productSuiteName);
  }
}
